import { LinkTypes, SOURCES_OPTIONS } from "./LinkTypes";
import { urlValidator, mailValidator } from "../../../helpers/validators";

export const findOption = (source, t) => {
  const options = SOURCES_OPTIONS(t);
  const option = options.find(({ value }) => source === value);

  return option || options[0];
};

export const formatLink = (link, source, onChange) => {
  if (source === LinkTypes.LINK) {
    let url = link.trim();
    let formattedUrl = "";

    if (urlValidator({ url })) {
      formattedUrl = url;
    } else {
      const correctedUrl = `https://${url.replace(/^\w+:\/\//, "")}`;
      if (urlValidator({ url: correctedUrl })) {
        formattedUrl = correctedUrl;
      }
    }

    if (link !== formattedUrl) {
      onChange({ link: formattedUrl, source: LinkTypes.LINK });
    }
  }

  if (source === LinkTypes.EMAIL) {
    if (!mailValidator({ url: link })) {
      onChange({ link: "", source: LinkTypes.EMAIL });
    }
  }
};
